/* =============================================================================
   WEDTREE · Minimum Order Quantity (MOQ)
   -----------------------------------------------------------------------------
   Source of truth: product metafield  information.minimum_order_quantity
   Liquid sets  min / value / data-wt-moq  on every quantity input (PDP, sticky
   bar, cart drawer, cart page) and a hidden quantity on quick-add forms.
   This script adds the experience layer:
     • free typing in the quantity box (no snapping mid-keystroke)
     • friendly inline messages instead of silent clamping
     • a nudge + message when "−" is pressed at the minimum
     • typing 0 in the cart removes the line (instead of snapping back)
     • live "N pcs · ₹total" on the product page
     • one-tap "Update to N pcs" for cart lines below the minimum
     • safety net on /cart/add and /cart/change requests
   ============================================================================= */
(function () {
  'use strict';
  if (window.WTMOQ) return;

  var TEXT = Object.assign({
    at_min: 'Minimum order for this item is <strong>{moq} pcs</strong>',
    at_min_cart: 'Minimum is <strong>{moq} pcs</strong>. Use <em>Remove</em> to take it out',
    typing: 'Minimum order is <strong>{moq} pcs</strong>',
    bumped: 'Set to <strong>{moq} pcs</strong> &mdash; the minimum order for this item',
    added_bumped: 'Added <strong>{moq} pcs</strong> &mdash; the minimum order for this item',
    total: '{qty} pcs &middot; {total}'
  }, window.WT_MOQ_TEXT || {});

  var MONEY_FORMAT = window.WT_MONEY_FORMAT || 'Rs. {{amount}}';
  var FLASH_MS = 3800;

  /* ---------- helpers ---------- */
  function fmt(str, vars) {
    return String(str).replace(/\{(\w+)\}/g, function (_, k) { return vars && vars[k] != null ? vars[k] : ''; });
  }
  function int(v) { var n = parseInt(v, 10); return isNaN(n) ? null : n; }
  function moqOf(input) { var m = int(input && input.getAttribute('data-wt-moq')); return m && m > 1 ? m : 0; }
  function isMoqInput(el) { return el && el.tagName === 'INPUT' && el.hasAttribute('data-wt-moq') && moqOf(el) > 0; }
  function isCartInput(el) { return el && el.hasAttribute('data-wt-moq-cart'); }

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = format || MONEY_FORMAT;
    function delim(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delim(cents, 0); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      default: value = delim(cents, 2);
    }
    if (/\.00$/.test(value)) value = value.slice(0, -3); // match money_without_trailing_zeros
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- note / message target ---------- */
  function noteFor(input) {
    var id = input.getAttribute('data-wt-moq-note');
    return id ? document.getElementById(id) : null;
  }
  function textEl(note) { return note && (note.querySelector('.wt-moq-text') || note); }

  function flash(input, html, tone) {
    var note = noteFor(input);
    if (!note) { toast(html); return; }
    var el = textEl(note);
    if (!el.hasAttribute('data-wt-moq-default')) el.setAttribute('data-wt-moq-default', el.innerHTML);
    el.innerHTML = html;
    note.classList.remove('is-alert', 'is-info');
    void note.offsetWidth; // restart animation
    note.classList.add(tone === 'info' ? 'is-info' : 'is-alert');
    clearTimeout(note._wtTimer);
    note._wtTimer = setTimeout(function () { reset(input); }, FLASH_MS);
  }
  function reset(input) {
    var note = noteFor(input);
    if (!note) return;
    var el = textEl(note);
    var def = el.getAttribute('data-wt-moq-default');
    if (def != null) el.innerHTML = def;
    note.classList.remove('is-alert', 'is-info');
  }
  function nudge(input) {
    var stepper = input.closest('[data-wt-moq-stepper]') || input.closest('.input-amount');
    if (!stepper) return;
    stepper.classList.remove('wt-moq-nudge');
    void stepper.offsetWidth;
    stepper.classList.add('wt-moq-nudge');
  }

  var toastEl, toastTimer;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wt-moq-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, FLASH_MS);
  }

  /* ---------- product page running total ---------- */
  function updateTotal(input) {
    var note = noteFor(input);
    if (!note) return;
    var totalEl = note.querySelector('[data-wt-moq-total]');
    if (!totalEl) return;
    var prices;
    try { prices = JSON.parse(note.getAttribute('data-wt-prices') || '{}'); } catch (e) { prices = {}; }
    var form = note.getAttribute('data-wt-form') ? document.getElementById(note.getAttribute('data-wt-form')) : null;
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var variantId = idInput ? idInput.value : Object.keys(prices)[0];
    var unit = prices[variantId];
    var qty = int(input.value);
    if (unit == null || !qty || qty < moqOf(input)) { totalEl.innerHTML = ''; return; }
    totalEl.innerHTML = fmt(TEXT.total, { qty: qty, total: formatMoney(unit * qty) });
  }
  function refreshTotals() {
    document.querySelectorAll('input[data-wt-moq]:not([data-wt-moq-cart])').forEach(function (input) {
      if (moqOf(input)) updateTotal(input);
    });
  }

  /* ---------- 1. free typing: keep the stepper from snapping mid-keystroke ---------- */
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!isMoqInput(input)) return;
    e.stopPropagation(); // capture phase: the stepper component only normalises on change
    var v = int(input.value), moq = moqOf(input);
    var stepper = input.closest('.input-amount');
    if (v !== null && v > 0 && v < moq) {
      if (stepper) stepper.classList.add('wt-moq-below');
      flash(input, fmt(TEXT.typing, { moq: moq }), 'info');
      updateTotal(input);
    } else {
      if (stepper) stepper.classList.remove('wt-moq-below');
      reset(input);
      updateTotal(input);
    }
  }, true);

  /* ---------- 2. commit: explain the correction, or remove on 0 in cart ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!isMoqInput(input)) return;
    var v = int(input.value), moq = moqOf(input);
    var stepper = input.closest('.input-amount');
    if (stepper) stepper.classList.remove('wt-moq-below');

    if (isCartInput(input) && v === 0) {
      var li = input.closest('li');
      var remove = li && li.querySelector('.remove-from-cart-link, a.remove');
      if (remove) { e.stopPropagation(); remove.click(); return; }
    }
    if (v === null || v < moq) {
      input.value = moq;
      flash(input, fmt(TEXT.bumped, { moq: moq }));
      nudge(input);
    }
    setTimeout(function () { updateTotal(input); }, 0);
  }, true);

  document.addEventListener('blur', function (e) {
    var input = e.target;
    if (!isMoqInput(input)) return;
    var v = int(input.value);
    if (v === null || (v > 0 && v < moqOf(input))) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);

  /* ---------- 3. "−" at the minimum: say why instead of doing nothing ---------- */
  document.addEventListener('click', function (e) {
    var ctrl = e.target.closest && e.target.closest('.input-amount a.decr');
    if (!ctrl) return;
    var stepper = ctrl.closest('.input-amount');
    var input = stepper && stepper.querySelector('input[data-wt-moq]');
    if (!isMoqInput(input)) return;
    var v = int(input.value) || 0, moq = moqOf(input);
    if (v <= moq) {
      e.preventDefault();
      e.stopPropagation();
      flash(input, fmt(isCartInput(input) ? TEXT.at_min_cart : TEXT.at_min, { moq: moq }));
      nudge(input);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var ctrl = e.target.closest && e.target.closest('.input-amount a.incr');
    if (!ctrl) return;
    var input = ctrl.closest('.input-amount').querySelector('input[data-wt-moq]');
    if (isMoqInput(input)) { reset(input); setTimeout(function () { updateTotal(input); }, 0); }
  });

  /* ---------- 4. cart lines below the minimum: one-tap fix ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wt-moq-fix]');
    if (!btn) return;
    e.preventDefault();
    var li = btn.closest('li');
    var input = li && li.querySelector('input[name="updates[]"]');
    var qty = int(btn.getAttribute('data-qty'));
    if (!input || !qty) return;
    btn.disabled = true;
    btn.classList.add('is-busy');
    input.value = qty;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Belt and braces: a blocked checkout button never submits */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.wt-moq-blocked');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var v = document.querySelector('[data-wt-moq-violation]');
    if (v) v.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  /* ---------- 5. network safety net (quick add, upsells, any other path) ---------- */
  function variantMoqMap() {
    var map = {};
    document.querySelectorAll('[data-wt-moq-ids]').forEach(function (el) {
      var moq = int(el.getAttribute('data-wt-moq'));
      if (!moq || moq < 2) return;
      (el.getAttribute('data-wt-moq-ids') || '').split(',').forEach(function (id) {
        id = id.trim();
        if (id) map[id] = Math.max(map[id] || 0, moq);
      });
    });
    return map;
  }
  function lineMoq(lineOrKey) {
    var sel = String(lineOrKey).indexOf(':') > -1
      ? 'input[data-wt-moq-cart][data-line-key="' + String(lineOrKey).replace(/"/g, '\\"') + '"]'
      : 'input[data-wt-moq-cart][data-line="' + lineOrKey + '"]';
    var input = document.querySelector(sel);
    return input ? moqOf(input) : 0;
  }
  function pathOf(url) {
    try { return new URL(url, window.location.href).pathname; } catch (e) { return ''; }
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (resource, init) {
      try {
        var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
        var path = pathOf(url);
        var body = init && init.body;
        if (body && /\/cart\/add(\.js)?$/.test(path)) {
          var map = variantMoqMap(), bumped = 0;
          if (body instanceof FormData) {
            var id = body.get('id'), q = int(body.get('quantity')) || 1;
            if (id && map[id] && q < map[id]) { body.set('quantity', String(map[id])); bumped = map[id]; }
          } else if (typeof body === 'string' && body.charAt(0) === '{') {
            var json = JSON.parse(body);
            var items = json.items || (json.id ? [json] : []);
            items.forEach(function (it) {
              var m = map[String(it.id)];
              if (m && (int(it.quantity) || 1) < m) { it.quantity = m; bumped = m; }
            });
            init.body = JSON.stringify(json);
          }
          if (bumped) setTimeout(function () { toast(fmt(TEXT.added_bumped, { moq: bumped })); }, 400);
        } else if (body && /\/cart\/change(\.js)?$/.test(path) && typeof body === 'string' && body.charAt(0) === '{') {
          var c = JSON.parse(body);
          var q2 = int(c.quantity);
          var m2 = lineMoq(c.line != null ? c.line : c.id);
          if (m2 && q2 > 0 && q2 < m2) { c.quantity = m2; init.body = JSON.stringify(c); }
        }
      } catch (err) { /* never block the request because of the safety net */ }
      return nativeFetch.apply(this, arguments);
    };
  }

  /* ---------- 6. keep totals fresh when the theme re-renders ---------- */
  ['DOMContentLoaded', 'pageshow'].forEach(function (ev) { window.addEventListener(ev, refreshTotals); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') setTimeout(refreshTotals, 50);
  });
  if (document.readyState !== 'loading') refreshTotals();

  window.WTMOQ = { flash: flash, toast: toast, formatMoney: formatMoney, refresh: refreshTotals };
})();
